import type { FaireProductEntity } from "../../entity_types/product";

export const p_pfx3gddkz9: FaireProductEntity = {
  token: "p_pfx3gddkz9",
  type: "product",
  name: "Sheer Floral Pattern T-Shirt",
  brandToken: "b_q6uy7uqavt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/43dfedde9718f143310ac8405cda4bb069439ae7e9ee823b4dc39847ea67b732.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d9a1ad1463025e3dd1500923e1f384fff0b88feea425a5478348da8449cae1d.jpeg",
    "https://cdn.faire.com/fastly/8ad1f96707e7bc8835e352298f6de25f90a63613a23a757d1425b4e0e000182c.jpeg",
    "https://cdn.faire.com/fastly/3361f7c46ff95ae0beeb1db2d4abc685f14463b1c6a7f84b2e665a22abcd0c24.jpeg",
    "https://cdn.faire.com/fastly/7b0ec1151ba926d54978b24d808d69f99988caaf4a8e9f8c700d81612e0e857f.jpeg",
    "https://cdn.faire.com/fastly/1a514f5efab8ddcd2b357899a442c1b8c52cd8b34f387090fbffe5a2acd51543.jpeg",
    "https://cdn.faire.com/fastly/684209f2288dfd6cdc87b98a9003bd1ece6a1759ed12258df5384c11ff775a0a.jpeg",
    "https://cdn.faire.com/fastly/4213d46241771341e59c5dbef8ffb58fcbd206fba1d534db68164cb281a3bdb0.jpeg",
    "https://cdn.faire.com/fastly/6585f5c4deacb668bab9bd33e631d8b890db37be0efe9dee1cbbc5596217cf1e.jpeg",
  ],
  priceDollars: 16.19,
  description:
    "Elegant, boho, and effortlessly chic—a perfect festival-ready top.\n\nFabric: 100% polyester\n\nWeight: 0.44 lb\n",
  tags: [],
  msrpDollars: 32.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:14.359Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
